import React, { Component } from 'react';
import { connect } from 'react-redux';
import CopyURLSegment from "../../SharedComponents/CopyURLSegment";
import { getQueryParamValue } from "../../Constants/getQueryParamValue";
import { Button } from 'semantic-ui-react';
import { toggleToast } from "../../Actions/ToggleToast";
import API_Backend_Root from "../../Constants/API_Backend_Root";
import { toggleModal } from "../../Actions/ToggleModal";
import yaml from "js-yaml";

class AiIndex extends Component {
  constructor(props) {
    super(props);
    this.state = { downloading: false };
  }

  componentDidMount() {
    // optional analytics
    fetch(API_Backend_Root + "store-analytics-from-ui/", {
      method: "POST",
      body: JSON.stringify({
        data: {
          Email: localStorage.getItem("email"),
          Notes: "User opened AI Spec tab",
          "Use Case": "AI",
          "Date Saved": new Date().toLocaleDateString(),
          "Usage Metrics": ""
        },
        headers: {
          accessKey: "2863a49b9ea04e9847cb90f0e0aa93d5",
          secretKey: "9eca419e34ff1e929f05d00598dfb679"
        },
        apiUrl: "https://api.apispreadsheets.com/data/Zh4Ob0LXhmZN3goL/",
        sendEmailAlert: false
      })
    }).catch(() => {});
  }

  // Build /spec/<file_id>/ and swap host to api.apispreadsheets.com
  buildSpecUrl = () => {
    let url = this.props.getURL.replace("/data/", "/spec/");
    // show a clean URL (no query)
    if (url.includes("?")) url = url.substring(0, url.indexOf("?"));
    // swap host only
    url = url.replace(/^https?:\/\/[^/]+/, "https://api.apispreadsheets.com");
    return url;
  };

  // Extract keys from the ORIGINAL URL (with query params)
  getAuthHeaders = () => {
    const original = this.props.getURL; // includes ?accessKey=...&secretKey=...
    const accessKey = getQueryParamValue("accessKey", original) || "";
    const secretKey = getQueryParamValue("secretKey", original) || "";

    const headers = { "Content-Type": "application/json" };
    if (accessKey) headers["accessKey"] = accessKey;
    if (secretKey) headers["secretKey"] = secretKey;
    return headers;
  };

  // POST → get JSON → YAML → download
  handleDownload = async () => {
    try {
      this.setState({ downloading: true });
      const specUrl = this.buildSpecUrl();
      const headers = this.getAuthHeaders();

      const res = await fetch(specUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({}) // add body fields if your endpoint expects them
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const specJson = await res.json();
      const yamlStr = yaml.dump(specJson, { noRefs: true, lineWidth: -1 });

      const blob = new Blob([yamlStr], { type: "application/x-yaml" });
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = "openapi-spec.yaml";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(href);

      this.props.toggleToast({ show: true, type: "success", message: "OpenAPI spec downloaded." });
    } catch (e) {
      this.props.toggleToast({ show: true, type: "error", message: `Failed to download spec: ${e.message}` });
    } finally {
      this.setState({ downloading: false });
    }
  };

  render() {
    const displayUrl = this.buildSpecUrl();

    return (
      <div>
        <CopyURLSegment
          url={displayUrl}
          header={
            <span>
              API URL
              <span
                style={{
                  backgroundColor: "orange",
                  color: "white",
                  fontSize: "85%",
                  padding: "0 4px",
                  fontWeight: 700,
                  marginLeft: "6px"
                }}
              >
                POST
              </span>
            </span>
          }
        />

        <br />

        <Button
          primary
          icon="download"
          content="Download OpenAPI (.yaml)"
          loading={this.state.downloading}
          disabled={this.state.downloading}
          onClick={this.handleDownload}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapActionsToProps = { toggleToast, toggleModal };

export default connect(mapStateToProps, mapActionsToProps)(AiIndex);
